export default function VersionFooter() {
    return <p>Version: {process.env.REACT_APP_VERSION}</p>
}
